import React from 'react';

function OpenSourceLabel() {
  const ca = process.env.REACT_APP_CA;

  // 如果没有CA地址，则不显示按钮
  if (!ca) {
    return null;
  }

  const bscscanUrl = `https://bscscan.com/address/${ca}#code`;

  const handleClick = () => {
    window.open(bscscanUrl, '_blank');
  };

  return (
    <button 
      onClick={handleClick}
      style={{
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        padding: '10px 15px',
        marginLeft: '10px',
        cursor: 'pointer',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        transition: 'background-color 0.2s'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
    >
      合约已开源(点击查看)
    </button>
  );
}

export default OpenSourceLabel; 